import React from 'react';
import * as C from "../componentsM/index";
import { Link } from 'react-router-dom';




const MeetTheAdmissionTeam = () => <>

    <C.Hero title={"MEET THE ADMISSIONS TEAM"} image={"/hero/13.jpg"} />




    <section className='p-4 md:p-24'>

        <div className='flex flex-col gap-5'>


            <p className='font-semibold'>Thank you for your interest in The International School.</p>

            <p className='font-semibold'>We accept admission applications throughout the year for our Primary, Middle and High School programmes. The number of openings in each grade varies from year to year depending on availability of seats.</p>

            <p className='font-semibold'>We invite you to initiate the <Link className='text-myBlue' to="/MeetTheAdmissionTeam">application process</Link> by completing our online <span className='text-myBlue'>enquiry</span>, calling +92 21 37130186-90 or by visiting our campus. The application process varies slightly for each programme, but all applications go through the same initial phases.</p>

            <p className='font-semibold'>The Admission’s staff is ready to help you with any questions you may have along the way.</p>

            <p className='font-semibold'>We look forward to your call and to welcoming you on campus.</p>

            <h1 className='font-bold text-myBlue text-xl md:text-3xl'>What leading academicians and alumni are saying about IB:</h1>

            <p className='font-semibold'>“The depth provided by IB subjects is completely adequate in the Arts and Humanities subjects as it is in the Biological sciences…” – Dr. Barnes of Emmanuel College, University of Cambridge</p>

            <p className='font-semibold'>“I would lean backwards to admit IB student” – Dr. Leobinger, Department of Physics, University of Manchester.</p>

            <p className='font-semibold'>“The style of questions in IB Mathematics examination are far less leading than those in A-Level papers and therefore more truly testing of the students mathematical training” – Dr. O. Pretzel, Department of Mathematics Admissions, Imperial College of Science, Technology and Medicine, University of London.</p>

            <p className='font-semibold'>“The IB allows students to think ‘out of the box’”, and helps to give them an openness of mind and a structure for their thinking” – Dr. S. Wharton, Modern Language Department, University of Bath.</p>

            <p className='font-semibold'>“The IB experience will remain with each of us forever as it shaped who we are. It has not only enriched our intellects, but also trained us to perceive the world with our mind’s eye” – Sanna Ahmad, Class of 2003, The International School.</p>


            <p className='font-semibold'>“IB is well known to us for excellent preparations. Success in an IB programme correlates well with success at Harvard. We are always pleased to see the credentials of the IB Diploma Programme on the transcript.” – Marilyn McGrath Lewis, Director of Undergraduate Admissions, Harvard University.</p>


            <p className='font-semibold'>“Send us prepared students a la IB It is the “best” high school prep curriculum an American school can offer…” – Marilee Jones, Former Director of Undergraduate Admission, Massachusetts Institute of Technology.</p>


        </div>

    </section>




</>
export default MeetTheAdmissionTeam